import { TurnBannerData } from '../types/darts';
import { useT } from '../hooks/useT';

interface TurnBannerProps {
  banner: TurnBannerData;
  isCountUp: boolean;
}

/**
 * Uitslag van de laatste beurt, over het toetsenbord heen. Tikken gaan erdoorheen naar het toetsenbord,
 * zodat de volgende speler meteen kan invoeren; de melding verdwijnt vanzelf of bij nieuwe invoer.
 */
export function TurnBanner({ banner, isCountUp }: TurnBannerProps) {
  const { t, tf } = useT();
  return (
    <div role="status" className="pointer-events-none absolute inset-0 z-30 flex items-center justify-center rounded-3xl p-2">
      <div
        className="animate-scale-up w-full max-w-sm space-y-2 rounded-3xl bg-white p-5 text-slate-900 shadow-2xl ring-2 ring-emerald-600 dark:bg-slate-900 dark:text-slate-100"
      >
        <p className="text-xs font-bold text-slate-600 uppercase dark:text-slate-400">{tf('turnResult', { name: banner.playerName })}</p>
        {banner.isBust ? (
          <p className="font-mono text-2xl font-extrabold text-red-700 dark:text-red-400">
            {banner.scoreBefore} − {banner.turnTotal} → {t('bust')} ({banner.scoreBefore})
          </p>
        ) : (
          <p className="flex items-center justify-center gap-2 font-mono text-4xl font-extrabold sm:text-5xl">
            <span className="text-slate-500 dark:text-slate-400">{banner.scoreBefore}</span>
            <span className="text-amber-700 dark:text-amber-400">
              {isCountUp ? '+' : '−'}
              {banner.turnTotal}
            </span>
            <span className="text-slate-400">=</span>
            <span className="text-emerald-700 dark:text-emerald-400">{banner.scoreAfter}</span>
          </p>
        )}
      </div>
    </div>
  );
}
